export default function BrandLogo({ org, size = 40, className = "" }) {
  const dim = { width: size, height: size };
  if (org?.logo_url) {
    return (
      <img
        src={org.logo_url}
        alt={org?.name || "Brand"}
        style={dim}
        className={`rounded-xl object-cover ${className}`}
        data-testid="brand-logo"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
    );
  }
  return (
    <div
      style={dim}
      data-testid="brand-logo-fallback"
      className={`grid place-items-center rounded-xl bg-brand-primary text-brand-primary-foreground font-heading font-extrabold ${className}`}
    >
      {org?.name?.[0]?.toUpperCase() || "B"}
    </div>
  );
}
